// extracted by mini-css-extract-plugin
module.exports = {"currencyFilter":"CurrencyFilter_currencyFilter__39FxY"};